<template>
  <div :class="main ? 'calculate-main' : ''">
    <template v-if="attributesCopy">
      <template v-for="(attribute, attrIndex) in attributesCopy">
        <typeList
          :key="attrIndex"
          :calculate="true"
          :main="main"
          :offer-id="offerId"
          :attr="attribute"/>
      </template>
      <div
        v-if="attributesCopy.length != 0"
        :class="main ? 'calculate-footer-main' : 'calculate-footer'">
        <button
          v-if="!main"
          class="btn btn-success"
          @click="checkPrice">
          Рассчитать цену
        </button>
        <button
          v-else
          class="btn btn-primary"
          @click="calculateAll">
          Рассчитать
        </button>
      </div>
      <div
        v-if="forAll"
        class="calculate-footer-all">
        <i>Рассчитать все цены для раздела</i>
        <nuxt-link
          class="category-name"
          :to="link">
          {{ categoryName }}
        </nuxt-link>
        <button
          class="btn btn-outline-secondary btn-calc-all"
          @click="calculateAll">
          Рассчитать для всех
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import typeList from "~/components/offer/calculate/typeList.vue";
import { makeFormulas } from "~/services/offer-formula-calculate";
import { getOfferList } from "~/services/offerList";
import axios from "axios";
import { parseBool } from "~/services/booleanParser";
import { getCategory } from "~/services/offerList";
export default {
  components: {
    typeList,
  },
  props: {
    categoryId: {
      type: Number,
      default: null,
    },
    categoryName: {
      type: String,
      default: "",
    },
    offerId: {
      type: Number,
      default: null,
    },
    attributes: {
      type: Array,
      default: () => [],
    },
    main: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Рассчитать цену",
    },
    forAll: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: null,
    },
    calculateReady: {
      type: Function,
      default: () => {},
    },
    calculateAllReady: {
      type: Function,
      default: () => {},
    },
    link: {
      type: String,
      default: "",
    },
    game: {
      type: Object,
      default: null,
    },
    getFiltersComponent: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      attributesCopy: JSON.parse(JSON.stringify(this.attributes)),
    };
  },
  computed: {
    ...mapGetters({
      activeCategory: "offerList/getActiveCategory",
    }),
  },
  methods: {
    checkPrice: function (e) {
      e.preventDefault();
      let postData = {};
      postData.offer_id = this.offerId;
      postData.attributesValues = makeFormulas(this.attributesCopy);
      return axios
        .post("/offers/price-and-time", postData)
        .then((response) => {
          if (response.data.success) {
            this.calculateReady({
              index: this.index,
              time: response.data.data.time,
              price: response.data.data.price,
              attrs: this.attributesCopy,
            });
          } else {
            let noty = this.$noty;
            response.data.data.forEach(function (item, index) {
              noty.error("Ошибка сервера. " + item.message);
            });
          }
        })
        .catch((exception) => {
          let noty = this.$noty;
          console.log(exception);
          if (exception.response) {
            if (!Array.isArray(exception.response.data.data)) {
              noty.error(
                "Ошибка сервера. " + exception.response.data.data.message
              );
            } else {
              exception.response.data.data.forEach(function (item, index) {
                noty.error("Ошибка сервера. " + item.message);
              });
            }
          }

          return exception.response;
        });
    },
    calculateAll: async function (e) {
      e.preventDefault();
      let activeCategory = null;
      if (!this.activeCategory || !this.activeCategory.attrs) {
        try {
          let activeCategoryResponse = await getCategory(this.categoryId);
          if (activeCategoryResponse.success) {
            activeCategory = activeCategoryResponse.data;
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        activeCategory = this.activeCategory;
      }

      let filters = activeCategory.attrs.filter(
        (item) => item.filters && item.filters.nothing == false
      );

      if (!filters) {
        filters = [];
      }

      let requestFilters = [];
      let attributesValues = makeFormulas(this.attributesCopy);

      let _this = this;
      let attributesNotFilled = false;
      Object.keys(attributesValues).forEach((item) => {
        if (!attributesValues[item]) {
          attributesNotFilled = true;
        }
      });

      if (attributesNotFilled) {
        this.$noty.error("Заполните атрибуты для расчета");
        return;
      }

      let priceAttributes = this.attributesCopy.filter(
        (item) => item.affects_price == 1 || item.affects_time == 1
      );

      priceAttributes.forEach((item) => {
        if (item.type == 0 && item.value && item.value != "") {
          item.filters = {
            yes: parseBool(item.value)
              ? parseBool(item.value)
                ? true
                : false
              : false,
            no: parseBool(item.value)
              ? parseBool(item.value)
                ? true
                : false
              : false,
            nothing: false,
          };
        }

        if (
          item.type == 1 &&
          item.view == 2 &&
          item.value &&
          item.value != ""
        ) {
          item.filters = {
            nothing: false,
            rangeSingle: item.value,
          };
        }

        if (
          ((item.type == 1 && item.view == null) ||
            (item.type == 2 && item.view == 1)) &&
          item.value &&
          item.value != ""
        ) {
          item.filters = {
            nothing: false,
            text: item.value,
          };
        }

        if (
          ((item.type == 1 && item.view == 3) ||
            (item.type == 2 && item.view == null)) &&
          parseInt(item.from) != NaN &&
          parseInt(item.to) != NaN
        ) {
          let newValue = item.value.split(",");
          item.filters = {
            nothing: false,
            rangeMultiple: {
              from: parseInt(newValue[0]),
              to: parseInt(newValue[1]),
            },
          };
        }

        if (item.type == 3 && item.view != 6) {
          let checked = item.availableValues.filter((val) => val.check === 1);
          let multiselect = {};
          checked.forEach((ch) => {
            multiselect[ch["id"]] = true;
          });
          item.filters = {
            nothing: false,
            multiselect: multiselect,
          };
        }

        if (
          item.type == 3 &&
          item.view == 6 &&
          item.value &&
          item.value != ""
        ) {
          item.filters = {
            nothing: false,
            select: parseInt(item.value),
          };
        }
      });

      attributesValues = {};
      priceAttributes.forEach((item) => {
        let existing = filters.filter((f) => f.id == item.id)[0];
        if (existing) {
          filters = filters.splice(existing);
        }
      });

      filters = filters.concat(priceAttributes);

      filters.forEach(async (item) => {
        if (item.filters && !item.filters.nothing) {
          if (item.affects_price == 1 || item.affects_time == 1) {
            if (item.type == 0) {
              if (item.filters.yes === true) {
                attributesValues[item.id] = 1;
              } else {
                attributesValues[item.id] = 0;
              }
            }

            if (
              item.filters.rangeMultiple &&
              parseInt(item.filters.rangeMultiple.from) != NaN &&
              parseInt(item.filters.rangeMultiple.to) != NaN
            ) {
              let value = [
                parseInt(item.filters.rangeMultiple.from),
                parseInt(item.filters.rangeMultiple.to),
              ];
              attributesValues[item.id] = value;
            }

            if (
              item.filters.rangeSingle &&
              parseInt(item.filters.rangeSingle) != NaN
            ) {
              let value = [parseInt(item.filters.rangeSingle)];
              attributesValues[item.id] = value;
            }

            if (item.filters.text) {
              let value = [parseInt(item.filters.text)];
              if (value && value != NaN) {
                attributesValues[item.id] = value;
              }
            }

            if (
              item.filters.multiselect &&
              Object.keys(item.filters.multiselect).length !== 0
            ) {
              let multiSelectValues = [];
              Object.keys(item.filters.multiselect).forEach((item) => {
                multiSelectValues.push(item);
              });
              attributesValues[item.id] = multiSelectValues;
            }

            if (item.filters.select) {
              let value = [parseInt(item.filters.select)];
              attributesValues[item.id] = value;
            }
          }

          let newAttr = {};
          Object.keys(item).forEach((obj) => {
            if (obj != "filters") {
              newAttr[obj] = item[obj];
            } else {
              newAttr.filters = {
                yes: item.filters.yes,
                no: item.filters.no,
                nothing: item.filters.nothing,
                rangeMultiple: {
                  from: item.filters.rangeMultiple
                    ? item.filters.rangeMultiple.from
                    : "",
                  to: item.filters.rangeMultiple
                    ? item.filters.rangeMultiple.to
                    : "",
                },
                text: item.filters.text,
                rangeSingle: item.filters.rangeSingle,
                select: item.filters.select,
                multiselect: item.filters.multiselect
                  ? item.filters.multiselect
                  : {},
                attributesValues: attributesValues,
              };
            }
          });

          requestFilters.push(newAttr);
        }
      });

      let filtersRequestData = requestFilters;

      let browserString = {};

      filtersRequestData.forEach((item) => {
        if (item.type == 0) {
          browserString[item.id] = { yes: item.filters.yes };
        }
        if (item.type == 1 && item.view == null) {
          browserString[item.id] = { text: item.filters.text };
        }
        if (item.type == 1 && item.view == 2) {
          browserString[item.id] = { rangeSingle: item.filters.rangeSingle };
        }

        if ((item.type == 1 && item.view == 3) || item.type == 2) {
          browserString[item.id] = {
            rangeMultiple: item.filters.rangeMultiple,
          };
        }

        if ((item.type == 3 && item.view != 6) || item.type == 4) {
          browserString[item.id] = { multiselect: item.filters.multiselect };
        }

        if (item.type == 3 && item.view == 6) {
          browserString[item.id] = { select: item.filters.select };
        }
      });

      let serialize = function (obj, prefix) {
        var str = [],
          p;
        for (p in obj) {
          if (obj.hasOwnProperty(p)) {
            var k = prefix ? prefix + "[" + p + "]" : p,
              v = obj[p];
            str.push(
              v !== null && typeof v === "object"
                ? serialize(v, k)
                : encodeURIComponent(k) + "=" + encodeURIComponent(v)
            );
          }
        }
        return str.join("&");
      };

      let filtersString = serialize(browserString, "filters");

      history.pushState(
        {},
        null,
        this.$route.path +
          "?" +
          (!filtersString || filtersString != "" ? filtersString : "")
      );

      try {
        /*let loader = this.$loading
          ? this.$loading.show({
              canCancel: false,
            })
          : null;*/
        let filterGetOffers = activeCategory
          ? "category_id=" + activeCategory.id
          : "game_id=" + this.game.id;
        filterGetOffers += "&per-page=50" + "&page=";

        let options = {};
        options.category_id = activeCategory.id;
        options.game_id = this.game.id;

        if (this.$route.name == "profile-userId") {
          options.user_id = parseInt(this.$route.params.userId);
        }

        options.status = 3;

        getOfferList(options, filtersRequestData).then((offersResponse) => {
          /*if (loader) {
              loader.hide();
            }*/
          if (offersResponse) {
            let offers = {};
            offers.items = offersResponse.offers.items;
            offers._meta = offersResponse.offers._meta;
            offers._links = offersResponse.offers._links;

            this.$store.dispatch("offerList/SET_OFFERS", offers).then(() => {
              this.$store.dispatch(
                "offerList/SET_ACTIVE_CATEGORY",
                activeCategory
              );

              this.$store.dispatch("offerList/SET_CALCULATE_CATEGORY_ATTRS", {
                offers: offersResponse.offers.items,
                categoryId: activeCategory.id,
                categoryName: activeCategory.name,
                attrs: this.attributesCopy,
              });

              this.calculateAllReady({
                categoryId: activeCategory.id,
                categoryName: activeCategory.name,
              });

              filtersRequestData.forEach(async (item) => {
                if (item.affects_price == 1 || item.affects_time == 1) {
                  await _this.$store
                    .dispatch(
                      "offerList/SET_ACTIVE_CATEGORY_ATTRIBUTE_FILTERS",
                      {
                        id: item.id,
                        filters: {
                          yes: item.filters.yes,
                          no: item.filters.no,
                          nothing: item.filters.nothing,
                          text: item.filters.text,
                          rangeSingle: item.filters.rangeSingle,
                          rangeMultiple: {
                            from: item.filters.rangeMultiple
                              ? item.filters.rangeMultiple.from
                              : null,
                            to: item.filters.rangeMultiple
                              ? item.filters.rangeMultiple.to
                              : null,
                          },
                          multiselect: item.filters.multiselect,
                          select: item.filters.select,
                        },
                      }
                    )
                    .then(() => {
                      let filtersComponent = _this.getFiltersComponent();
                      if (filtersComponent) {
                        Object.keys(filtersComponent.$refs).forEach((item) => {
                          if (filtersComponent.$refs[item][0]) {
                            filtersComponent.$refs[
                              item
                            ][0].setActiveCategoryAttributeFilters();
                          }
                        });
                        filtersComponent.updateFiltersKey();
                      }
                      filtersComponent.$forceUpdate();
                    });
                }
              });
            });
            this.$forceUpdate();
          } else {
            this.$noty.error("Что-то пошло не так.");
          }
        });
      } catch (exception) {
        this.$noty.error("Что-то пошло не так. " + exception);
        return exception;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.calculate-header {
  margin-bottom: 20px;
  padding: 10px 16px;
  font-size: 10px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #6e7279;
  border-bottom: 1px solid #eff1f4;
}
.calculate-footer {
  padding-bottom: 20px;
  text-align: center;
  .btn-success {
    width: 230px;
    max-width: 100%;
  }
}
.attribute-formula-range {
  display: flex;
  justify-content: space-between;
  .range {
    width: 48%;
  }
}

.attribute {
  margin-bottom: 20px;
  padding: 0 20px;
}
.calculate-main {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding-right: 130px;
  padding-top: 10px;
  line-height: 1.2;
}
.calculate-header-main {
  padding-right: 15px;
  line-height: 64px;
  border-right: 2px solid #eff1f4;
}
.calculate-footer-main {
  position: absolute;
  top: 31px;
  right: 15px;
}

.category-name {
  margin-top: 5px;
  margin-bottom: 10px;
  display: block;
  width: 100%;
  color: $blue;
  cursor: pointer;
}

.calculate-footer-all {
  padding: 12px 15px 15px;
  border-top: 1px solid #eff1f4;
  text-align: center;
  i {
    font-style: normal;
    font-size: 12px;
    color: $body-color;
  }
}

.btn-calc-all {
  width: 100%;
}
</style>
